export const INVITE_NUDGE_SEEN_KEY = "join_invite_nudge_dismissed";

export type InviteNudgeEnvironment = {
  seen: boolean;
  // The home-screen install prompt occupies the same spot; never stack both.
  homeScreenPromptActive: boolean;
};

export function hasSeenInviteNudge(): boolean {
  try {
    return window.localStorage.getItem(INVITE_NUDGE_SEEN_KEY) === "1";
  } catch {
    return false;
  }
}

export function markInviteNudgeSeen() {
  try {
    window.localStorage.setItem(INVITE_NUDGE_SEEN_KEY, "1");
  } catch {
    // The nudge still closes for the current session if storage is unavailable.
  }
}

export function currentInviteNudgeEnvironment(homeScreenPromptActive: boolean): InviteNudgeEnvironment {
  return {
    seen: hasSeenInviteNudge(),
    homeScreenPromptActive
  };
}

// Shown once to every user: as soon as it surfaces we record it as seen, so it
// never reappears in a later session. It also yields to the install prompt.
export function shouldShowInviteNudge(environment: InviteNudgeEnvironment): boolean {
  return !environment.seen && !environment.homeScreenPromptActive;
}
